import React from 'react';
import { Layout } from '../components/layout/Layout';
import { SEO } from '../components/SEO';
import { HeroSection } from '../components/home/HeroSection';
import { IntroSection } from '../components/home/IntroSection';
import { PricingSection } from '../components/home/PricingSection';
import { TrustBadgesSection } from '../components/home/TrustBadgesSection';
export function HomePage() {
  return <Layout data-id="element-397">
      <SEO data-id="element-398" />
      <HeroSection data-id="element-399" />
      <IntroSection data-id="element-400" />
      <PricingSection data-id="element-401" />
      <TrustBadgesSection data-id="element-402" />

      {/* CTA Section */}
      <section className="py-20 bg-teal-600 text-white" data-id="element-403">
        <div className="container mx-auto px-4 text-center" data-id="element-404">
          <h2 className="text-3xl font-bold mb-6" data-id="element-405">
            Ready to streamline your business?
          </h2>
          <p className="text-teal-100 mb-8 max-w-2xl mx-auto text-lg" data-id="element-406">
            Join hundreds of UK businesses using HomeLinkPro to manage their
            daily operations.
          </p>
          <a href="/contact" className="inline-flex items-center justify-center h-12 px-8 rounded-lg bg-white text-teal-600 font-bold hover:bg-teal-50 transition-colors shadow-lg" data-id="element-407">
            Get Started Today
          </a>
        </div>
      </section>
    </Layout>;
}